import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import TemperatureViewModel from "@/models/TemperatureViewModel";
export default function () {
    const get = async (): Promise<TemperatureViewModel> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.get(`/api/temperature`)
                .then((result: AxiosResponse<TemperatureViewModel>) => {
                    if (result.status === 200) {
                        resolve(result.data);
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    return {
        get,
    };
}
